import { useBrand } from '@ui/config/BrandProvider';

export const BrandThemeStyle = () => {
  const brand = useBrand();

  return (
    // eslint-disable-next-line i18next/no-literal-string
    <style jsx global>{`
      :root,
      html[data-brand='${brand.id}'] {
        --colors-primary-primary: ${brand.theme.primary};
        --colors-primary-orange: ${brand.theme.primary};
        --colors-price-price-up-emphasized: ${brand.theme.primary};
        --colors-black-background: ${brand.theme.pageBg};
        --brand-nav-bg: ${brand.theme.navBg};
        --brand-active-nav: ${brand.theme.activeNav};
      }
    `}</style>
  );
};

